<template>
  <b-card>
    <b-card-title class="mb-1">Solicitações de alteração de snapshot</b-card-title>
    <b-card-sub-title class="mb-2">
      O pedido, quem decidiu e o que aconteceu. A modificação efetiva das linhas fica no histórico
      do snapshot.
    </b-card-sub-title>

    <div v-if="loading" class="text-center py-2">
      <b-spinner small />
    </div>

    <div v-else-if="!items.length" class="text-muted py-1">
      Nenhuma solicitação registrada para este contrato.
    </div>

    <b-table
      v-else
      :items="items"
      :fields="fields"
      responsive
      small
      class="mb-0"
    >
      <template #cell(status)="data">
        <b-badge :variant="statusVariant(data.item.status)">
          {{ statusLabel(data.item.status) }}
        </b-badge>
      </template>

      <template #cell(proposed_total_percentage)="data">
        {{ percentage(data.item.proposed_total_percentage) }}
      </template>

      <template #cell(created_at)="data">
        {{ dateTime(data.item.created_at) }}
      </template>

      <template #cell(actions)="data">
        <b-button size="sm" variant="outline-primary" @click="openRequest(data.item)">
          Detalhes
        </b-button>
      </template>
    </b-table>

    <snapshot-change-request-sidebar @decided="load" />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardSubTitle,
  BTable,
  BBadge,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapActions } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { apiErrorToast } from "@/helpers/error_messages";
import { statusLabel, statusVariant } from "@/constants/snapshot_change";
import SnapshotChangeRequestSidebar from "./SnapshotChangeRequestSidebar";
import * as types from "../store/types";

export default {
  components: {
    BCard,
    BCardTitle,
    BCardSubTitle,
    BTable,
    BBadge,
    BButton,
    BSpinner,
    SnapshotChangeRequestSidebar,
  },
  props: {
    contractId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      requests: [],
      fields: [
        { key: "status", label: "Status" },
        { key: "proposed_total_percentage", label: "Total proposto" },
        { key: "requested_by_name", label: "Solicitante" },
        { key: "created_at", label: "Solicitado em" },
        { key: "actions", label: "" },
      ],
    };
  },
  computed: {
    items() {
      return this.requests;
    },
  },
  setup() {
    return { toast: useToast() };
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      getRequestsByContract: types.GET_REQUESTS_BY_CONTRACT,
      openRequestSidebar: types.OPEN_REQUEST_SIDEBAR,
    }),
    statusLabel,
    statusVariant,
    load() {
      this.loading = true;

      this.getRequestsByContract({ contractId: this.contractId, params: { limit: 50 } })
        .then((response) => {
          this.requests = response.data?.data || [];
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: apiErrorToast(
              error,
              "Não foi possível carregar as solicitações de alteração de snapshot."
            ),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openRequest(request) {
      this.openRequestSidebar({ request });
    },
    percentage(value) {
      return `${Number(value || 0).toFixed(2).replace(".", ",")}%`;
    },
    dateTime(value) {
      if (!value) return "—";

      return new Date(value).toLocaleString("pt-BR");
    },
  },
};
</script>
